


















import Vue from 'vue'
export default Vue.extend({
  name: 'IconMail',
  props: {
    color: {
      type: String,
      default: 'white',
    },
  },
})
